@if ((customisation.config|async)?.pad_agreement; as padModel) {
  <mat-card
    class="form-mat-card"
    >
    <mat-icon class="back-button" (click)="goBack()" svgIcon="pq:chevron_left"></mat-icon>
    <div [innerHtml]="padModel.body"></div>
  </mat-card>
}
